import React from 'react';
import ReactDOM from 'react-dom';
import 'react-toastify/dist/ReactToastify.css';
import './assets/styles/index.scss';
import App from './components/App/App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './config/redux/store';
import { ToastContainer } from 'react-toastify';
import { ReactComponent as CloseButton } from './assets/icons/cross-gray.svg';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';
import { Wrapper as GoogleMapWrapper } from '@googlemaps/react-wrapper';

const persistor = persistStore(store);

const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_MAP_API_KEY as string;
ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        {/* console log leak warning missed, but load api on auth stage is not necessary */}
        <GoogleMapWrapper apiKey={GOOGLE_API_KEY} libraries={['places']}>
          <App />
        </GoogleMapWrapper>
      </PersistGate>
      <ToastContainer autoClose={7000} icon={false} hideProgressBar closeButton={() => <CloseButton />} />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root'),
);

/**
 * Hack to calculate real screen size in mobile browsers
 */
function appHeight() {
  const doc = document.documentElement;
  doc.style.setProperty('--vh', window.innerHeight * 0.01 + 'px');
}

window.addEventListener('resize', appHeight);
appHeight();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
